import React, { Component } from 'react';
import PropTypes from 'prop-types';
import api from '../utils/api'

class ContactForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: {
                value: "",
                hasError: true,
                touched: false,
            },
            email: {
                value: "",
                hasError: true,
                touched: false,
            },
            subject: {
                value: "",
                hasError: true,
                touched: false,
            },
            message: {
                value: "",
                hasError: true,
                touched: false,
            },
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.validateInput = this.validateInput.bind(this);
    }

    validateInput(input, controlState) {
        const inputvalue = input.type === 'checkbox' ? input.checked : input.value;
        const name = input.id.replace("contact-", "");
        let isValid = false;
        if (name === 'email')
            isValid = inputvalue.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        else
            isValid = inputvalue.length > 0;
        controlState.hasError = !isValid;
        this.setState({
            [name]: controlState
        });
    }

    handleBlur(event) {
        const target = event.target;
        const name = target.id.replace("contact-", "");
        let controlState = Object.assign({}, this.state[name], { touched: true });
        this.validateInput(target, controlState);
    }

    handleInputChange(event) {
        const target = event.target;
        const inputvalue = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.id.replace("contact-", "");

        let controlState = Object.assign({}, this.state[name], { value: inputvalue });

        //if (this.state[name].hasError && this.state[name].touched)
        this.validateInput(target, controlState);
        //else {
        //   this.setState({
        //       [name]: controlState
        //   });
        //}
    }

    handleSubmit(event) {
        let params = {
            From: this.state.email.value,
            Subject: this.state.subject.value,
            Message: this.state.message.value + "<br/>Inviato da:" + this.state.name.value
        }
        //api.sendContactEmail(params);
        api.sendContactEmail(params).then(function (data) {
            alert(data);
            return true;
        }).bind(this);
        event.preventDefault();
    }

    render() {
        const disableSubmitBtn = this.state['name'].hasError || this.state['email'].hasError || this.state['subject'].hasError || this.state['message'].hasError;
        return (
            <form onSubmit={this.handleSubmit}>
                <div className="row">
                    <div className="col-md-6">
                        <div className="md-form">
                            <div className="md-form">
                                <input type="text" id="contact-name" className={this.state['name'].hasError && this.state['name'].touched ? 'form-control error' : 'form-control'} onChange={this.handleInputChange} onBlur={this.handleBlur} />
                                <label htmlFor="contact-name" className="">Nome {this.state['name'].hasError && this.state['name'].touched && <span className="errorlabel">(campo obbligatorio)</span>}</label>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="md-form">
                            <div className="md-form">
                                <input type="text" id="contact-email" className={this.state['email'].hasError && this.state['email'].touched ? 'form-control error' : 'form-control'} onChange={this.handleInputChange} onBlur={this.handleBlur} />
                                <label htmlFor="contact-email" className="">Email {this.state['email'].hasError && this.state['email'].touched && <span className="errorlabel">(email non corretta)</span>}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="md-form">
                            <input type="text" id="contact-subject" className={this.state['subject'].hasError && this.state['subject'].touched ? 'form-control error' : 'form-control'} onChange={this.handleInputChange} onBlur={this.handleBlur} />
                            <label htmlFor="contact-Subject" className="">Oggetto {this.state['subject'].hasError && this.state['subject'].touched && <span className="errorlabel">(campo obbligatorio)</span>}</label>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="md-form">
                            <textarea style={{ minHeight: '5rem' }} type="text" id="contact-message" className={this.state['message'].hasError && this.state['message'].touched ? 'md-textarea error' : 'md-textarea'} onChange={this.handleInputChange} onBlur={this.handleBlur} ></textarea>
                            <label htmlFor="contact-message">Messaggio {this.state['message'].hasError && this.state['message'].touched && <span className="errorlabel">(campo obbligatorio)</span>}</label>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="text-center">
                            <button type="submit" value="Submit" className="btn accent-bkg" disabled={disableSubmitBtn}>Invia <i className="fas fa-paper-plane ml-1"></i></button>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

ContactForm.propTypes = {
    apiurl: PropTypes.string.isRequired
};

export default ContactForm;


// WEBPACK FOOTER //
// ./src/components/ContactForm.js